import { Skeleton } from '@mantine/core';
import { IconArrowsSort, IconX } from '@tabler/icons-react';

import { UnstyledButton } from '~/domains/design-system/Button';
import IconChevronDown from '~/domains/design-system/icons/IconChevronDown';
import { Text } from '~/domains/design-system/Text';

import type { TFilter } from './types';
import useStyles from './Filters.styles';

type FilterButtonProps = {
  filter: TFilter;
  clearFilters: (e: React.MouseEvent<HTMLButtonElement>) => (key: string) => void;
  setOpennedFilter: (filter: TFilter) => void;
  setIsDrawerOpen: (isOpen: boolean) => void;
};
function FilterButton({
  filter,
  setOpennedFilter,
  setIsDrawerOpen,
  clearFilters,
}: FilterButtonProps) {
  const { classes, cx, theme } = useStyles();
  const isLoading = !!filter.isLoading;

  return (
    <UnstyledButton
      key={filter.key}
      className={cx(classes.pill, { isActive: filter.isActive, isLoading })}
      onClick={() => {
        if (isLoading) return;

        setOpennedFilter(filter);
        setIsDrawerOpen(true);
      }}
    >
      {filter.key === 'SORT_BY' && (
        <IconArrowsSort color={filter.isActive ? theme.white : theme.colors.gray2[7]} size={16} />
      )}
      {isLoading ? (
        <Skeleton height={20} width={50} radius="xl" />
      ) : (
        <Text variant="subhead-small">{filter.activeLabel || filter.title}</Text>
      )}
      {!isLoading && filter.key !== 'SORT_BY' && !filter.isActive && (
        <IconChevronDown color={filter.isActive ? theme.white : theme.colors.gray2[7]} />
      )}
      {filter.isActive && (
        <UnstyledButton
          onClick={(e) => clearFilters(e)(filter.key)}
          className={classes.clearButton}
        >
          <IconX color={theme.white} size={16} />
        </UnstyledButton>
      )}
    </UnstyledButton>
  );
}

export default FilterButton;
